import React from 'react'
import { Link } from 'react-router-dom'

// paths = [{title: "Admin", to: '/admin'}]
const Breadcrumbs = ({ paths, style }) => {
  const len = paths.length - 1
  return (
    <ul className="bp3-breadcrumbs" style={style}>
      {paths.map((p, i) => (
        <li key={p.title}>
          {i === len ? (
            <span className="bp3-breadcrumb-current">{p.title}</span>
          ) : (
            <Link to={p.to} className="bp3-breadcrumb">
              {p.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  )
}

// workaround for Jest https://github.com/airbnb/enzyme/issues/1875
export { Breadcrumbs }
export default React.memo(Breadcrumbs)
